module.exports = __webpack_public_path__ + "static/media/PhD_Information_Brochure2.73aa8aef.pdf";